import { lazy } from "react";

const QuadraturesActivity = lazy(() => import("./QuadraturesActivity"));

/**
 * The Quadratures Activity Page.
 */
const QuadraturesActivityConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "process-monitor/cuadraturas",
      element: <QuadraturesActivity />,
    },
  ],
};

export default QuadraturesActivityConfig;
